<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  // Import Bulma's core
  @import "~bulma/sass/utilities/initial-variables";
  @import "~bulma/sass/utilities/functions";

  // Colors based on bulmaswatch/sandstone
  $grey-darker:  #2a2a26;
  $grey-dark:    #3E3F3A;
  $grey:         #8E8C84;
  $grey-light:   #c9c8b8;
  $grey-lighter: #e6e1d7;

  $white-ter:    #F8F5F0;

  $orange:       #F47C3C;
  $green:        #93C54B;
  $blue:         #29ABE0;
  $red:          #d9534f;

  $primary: #325D88;
  $primary-invert: findColorInvert($primary);

  $family-heading: "News Cycle", "Arial Narrow Bold", sans-serif;

  $radius: 4px;

  $navbar-item-hover-color: $primary;
  $navbar-item-active-color: $primary;

  // Links
  $link: $primary;
  $link-invert: $primary-invert;
  $link-focus-border: $primary;

  // Import Bulma and Buefy styles
  @import "~bulma";
  @import "~buefy/src/scss/buefy";

  // Overrides
  @import url(https://fonts.googleapis.com/css?family=News+Cycle:400,700);

  body {
    font-size: 1.2rem;
  }

  .button,
  .input,
  .pagination-ellipsis,
  .pagination-link,
  .pagination-next,
  .pagination-previous,
  .select,
  .select select,
  .textarea,
  .control.has-icons-left .icon,
  .control.has-icons-right .icon {
    height: 2.5em;
  }

  .button {
    font-family: $family-heading;
    font-weight: 700;
    padding-left: 1em;
    padding-right: 1em;
  }

  .card-header-title,
  .menu-label,
  .message-header,
  .modal-card-title,
  .panel-heading,
  .subtitle,
  .title,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    font-family: $family-heading;
  }

  .notification {
    @each $name, $pair in $colors {
      $color: nth($pair, 1);
      $color-invert: nth($pair, 2);

      &.is-#{$name} {
        a:not(.button) {
          color: $color-invert;
          text-decoration: underline;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// App.vue?0bf81ff9